module.exports = __webpack_public_path__ + "static/media/wge3.png.b6957a29.jpg";